export const FETCH_TASKS = '@TASKS_LIST/FETCH_TASKS';
export const PUT_TASKS = '@TASKS_LIST/PUT_TASKS';
export const ADD_TASK = '@TASKS_LIST/ADD_TASK';
export const PATCH_TASK = '@TASKS_LIST/PATCH_TASK';

export const actionCreators = {
    fetchTasks: () =>  ({ type: FETCH_TASKS }),
    putTasks: (task) => ({ type: PUT_TASKS, payload: task }),
    addTask: (task) => ({ type: ADD_TASK, payload: task }),
    patchTask: (task) => ({ type: PATCH_TASK, payload: task }),
};
